<nb-card class="card-box" id="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="play-circle-outline" status="basic"></nb-icon>
        <span class="title">{{'printouts.printout-details' | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="close()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="confirmation-box">
        <div class="image-box">
            <img [class.image-box__image]="modalData.file.preview"
                [src]="modalData.file.preview"
                appImgFallback
                [removeClassesOnError]="true"
                appImgFallback alt="roboze-photo">
        </div>
        <div class="file-name-box">
            {{modalData.file.name}}
        </div>
        <div class="device-type-box">
            {{'device.details.model' | translate}}: <span class="value">Roboze {{ modalData.device.type }}</span>
        </div>
        <div class="material-box" *ngFor="let metadata of modalData.file.materials">
            {{'device.files.printing-material' | translate}}: <span class="value">{{metadata?.name}}</span>
            ({{metadata.used | number :'1.0-3'}}{{metadata.unit}})
        </div>
        <div class="date">
            {{'common.start-date' | translate}}: <span class="value">{{modalData.file.startDate | utcToLocaleDateTime}}</span>
        </div>
        <div class="date">
            {{'common.end-date' | translate}}: <span class="value">{{modalData.file.endDate | utcToLocaleDateTime}}</span>
        </div>
        <div class="owner">
            {{'device.details.print-owner' | translate}}: <span class="value">{{(modalData.file.owner ?? 'common.printer') | translate}}</span>
        </div>
    </nb-card-body>
    <nb-card-footer class="content-footer">
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" (click)="close()" tabindex="-1">
            {{'common.close' | translate}}
        </button>
    </nb-card-footer>
</nb-card>